import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import profileImgSVG from '../../assets/img/profileImg.svg.js';

var _templateObject, _templateObject2, _templateObject3;
var BaseProfileImage = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-end;\n  min-height: 215px;\n  ", "\n  padding: 20px;\n  ", "\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n"])), function (_ref) {
  var fluid = _ref.fluid;
  return fluid ? "width: 100%;" : "min-width: 306px;";
}, function (_ref2) {
  var square = _ref2.square;
  return square && "padding: 0px 0px 100% 0px; min-width: 215px;";
});
var ProfileImage = styled(BaseProfileImage)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  opacity: 0.9;\n  background-image: ", ";\n  @media (max-width: 576px) {\n    padding: 20px;\n  }\n"])), "url(".concat(profileImgSVG, ")"));
var ProfileImageBox = styled(BaseProfileImage)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  cursor: ", ";\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-image: ", ";\n"])), function (_ref3) {
  var onClick = _ref3.onClick;
  return onClick ? "pointer" : "default";
}, function (props) {
  return "url(".concat(props.photo, ")");
});
ProfileImage.displayName = "ProfileImage";
ProfileImage.propTypes = {
  photo: PropTypes.string,
  fluid: PropTypes.bool
};
var ProfileImg = (function (_ref4) {
  var fluid = _ref4.fluid,
    square = _ref4.square,
    photo = _ref4.photo,
    vertical = _ref4.vertical,
    children = _ref4.children,
    onClick = _ref4.onClick;
  return /*#__PURE__*/React__default.createElement(ProfileImage, {
    fluid: fluid,
    square: square,
    vertical: vertical
  }, photo ? /*#__PURE__*/React__default.createElement(ProfileImageBox, {
    "data-testid": "profile-img-box",
    onClick: onClick,
    photo: photo,
    fluid: fluid
  }) : null, children);
});

export { ProfileImg as default };
